import { Inject } from '@odinjs/odin';
import { ModalService, PanelAPI, RadioGroupAPI } from '@philips-internal/oswald-ui-components';

import Controller, { OnBeforeSubmit, OnCancel, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../../BaseController';
import { faceExpressionData } from './RadioGroupData/face-expression-data';
import { mechanicalVentilationData } from './RadioGroupData/mechanical-ventilation-data';
import { upperLimbsData } from './RadioGroupData/upper-limbs-data';
import './behavior-pain-scale-controller.css';

@Controller({ component: 'behavior-pain-scale-layout', fragment: 'behavior-pain-scale' })
class BehaviorPainScaleController extends BaseController {

  @Inject('reference-modal')
  panelLoaderModalApi!: PanelAPI;

  @Inject('face-expression-radio-group')
  faceExpressionRadioGroupApi!: RadioGroupAPI;

  @Inject('mechanical-ventilation-radio-group')
  mechanicalVentilationRadioGroupApi!: RadioGroupAPI;

  @Inject('upper-limbs-radio-group')
  upperLimbsRadioGroupApi!: RadioGroupAPI;

  @OnMount({target: 'face-expression-form'})
  onMountFaceExpressionForm(): void {
    this.faceExpressionRadioGroupApi.setData(faceExpressionData);
    this.faceExpressionRadioGroupApi.setValue(faceExpressionData[0]);
  }

  @OnMount({target: 'mechanival-ventilation-form'})
  onMountMechanicalVentilationForm(): void {
    this.mechanicalVentilationRadioGroupApi.setData(mechanicalVentilationData);
    this.mechanicalVentilationRadioGroupApi.setValue(mechanicalVentilationData[0]);
  }

  @OnMount({target: 'upper-limbs-form'})
  onMountUpperLimbsForm(): void {
    this.upperLimbsRadioGroupApi.setData(upperLimbsData);
    this.upperLimbsRadioGroupApi.setValue(upperLimbsData[0]);
  }

  @OnClose({ target: 'modal-pain-scale-reference' })
  onCloseModal(): void {
    this.panelLoaderModalApi.setVisible(false);
  }

  @OnClick({ target: 'reference-link'})
  onClickReference(): void {
    this.panelLoaderModalApi.setVisible(true);
  }

  @OnCancel({ target: 'upper-limbs-form' })
  onClickCancel(): void {
    ModalService.close('behavior-pain-scale');
  }

  @OnBeforeSubmit({ target: 'upper-limbs-form' })
  onBeforeSubmitForm(): void {
    const setPainScaleValue = this.context.get('setPainScaleValue');
    setPainScaleValue(Number(this.faceExpressionRadioGroupApi?.getValue()?.value)
                      + Number(this.mechanicalVentilationRadioGroupApi?.getValue()?.value)
                      + Number(this.upperLimbsRadioGroupApi?.getValue()?.value));

    ModalService.close('behavior-pain-scale');
  }
}
export default BehaviorPainScaleController;
